import { MOSCOW_AND_MO_IDS } from '../../constants/region';

export function isMoscowOrMO(regionId: number) {
  return MOSCOW_AND_MO_IDS.includes(regionId);
}
